import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import ResetPasswordSuccessController from './reset-password-success.controller';
import { Button as AntButton } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import styles from './styles/reset-password-success.module.scss';

/**
 * @extends ClockoutController
 * @extends ResetPasswordSuccessController
 * @extends Component
 */
class ResetPasswordSuccess extends Inherit(ResetPasswordSuccessController, Component) {
    render() {
        return (
            <div className={styles.successContainer}>
                <div className={styles.leftSection}>
                    <div className={styles.logoContainer}>
                        <img src="/logo-color.png" alt="Clockout Logo" className={styles.logo} />
                    </div>
                    
                    <div className={styles.contentWrapper}>
                        <div className={styles.headerSection}>
                            <h1 className={styles.title}>Password Reset Complete</h1>
                            <p className={styles.subtitle}>
                                Your password has been successfully updated. You can now sign in with your new password.
                            </p>
                        </div>

                        <div className={styles.imageSection}>
                            <img src="/phone-ux.png" alt="Clockout App Preview" className={styles.phoneImage} />
                        </div>
                    </div>
                </div>

                <div className={styles.rightSection}>
                    <div className={styles.formHeader}>
                        <span className={styles.alreadyHaveAccount}>Ready to get started?</span>
                        <AntButton 
                            type="text" 
                            onClick={() => this.navigateToSignIn()}
                            className={styles.signInButton}
                        >
                            Sign in
                        </AntButton>
                    </div>

                    <div className={styles.successCard}>
                        <div className={styles.successContent}>
                            <div className={styles.checkmarkWrapper}>
                                <div className={styles.checkmarkCircle}>
                                    <CheckCircleOutlined className={styles.checkmarkIcon} />
                                </div>
                            </div>
                            
                            <h2 className={styles.successTitle}>Password Reset Successful!</h2>
                            <p className={styles.successSubtitle}>
                                Your password has been updated. You can now sign in with your new credentials.
                            </p>

                            <AntButton
                                type="primary"
                                size="large"
                                onClick={() => this.continueToSignIn()}
                                className={styles.continueButton}
                                block
                            >
                                Sign In
                            </AntButton>
                        </div>
                    </div>
                </div>

                <div className={styles.footer}>
                    <span className={styles.copyright}>Copyright © 2025 Clockout Financial Inc.</span>
                    <div className={styles.footerLinks}>
                        <a href="/terms" className={styles.footerLink}>Terms and Conditions</a>
                        <a href="/privacy" className={styles.footerLink}>Privacy Policy</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withHooks(ResetPasswordSuccess);

